<script>
import Filters from '../../filters'
import Helpers from '../../helpers'

export default {
    props: {
        availableLanguages: {
            type: Array,
        },
        exportGroups: {
            type: Array,
        },
        massActionStatus: {
            type: Object,
        },
    },
    mixins: [Filters, Helpers],
    data() {
        return {
            folders: [],
            exportLoading: false,
            copySourceLanguage: '',
            copyLanguagesSelection: '',
            copyFolderSelection: '',
            copyLanguages: [],
            copyFolders: [],
            copyUpdate: null,
            copyUpdateCompleted: null,
            disableCopyButton: true,
            disableTradosButton: true,
            tradosSourceLanguage: '',
            tradosTypes: [
                {'value': 'folder', 'label': this.$t('Folders')},
                {'value': 'reference', 'label': this.$t('References')},
                {'value': 'file', 'label': this.$t('Files')},
            ],
            selectedTradosType: 'folder',
            tradosScopes: [
                {'value': '', 'label': this.$t('All')},
                {'value': 'last', 'label': this.$t('Since last export')},
                {'value': 'id', 'label': this.$t('ID')},
            ],
            selectedTradosScope: '',
            selectedTradosId: '',
            tradosLanguages: [],
            tradosUpdate: null,
            tradosUpdateCompleted: null,
            tradosProcessing: false,
        }
    },
    mounted() {
        this.$root.fetch('folder', {count: -1}).then(response => {
            this.folders = response.Folder
        })
    },
    methods: {
        updateCopyData() {
            this.$root.fetch('file', {
                action: 'copyFileI18nCheck',
                sourceLanguage: this.copySourceLanguage,
                targetLanguages: (this.copyLanguagesSelection === 'all' ? '*' : this.copyLanguages.join(',')),
                sourceFolders: (this.copyFolderSelection === 'all' ? '*' : this.copyFolders.join(',')),
            })
                .then((response) => {
                    if (response.success) {
                        this.disableCopyButton = false
                        this.copyUpdate = response.data
                    } else {
                        this.disableCopyButton = true
                        this.copyUpdate = null
                        this.errorMessage = this.$t('Something went wrong. Please contact administrator.')
                        console.log(response.message)
                    }
                })
        },
        performCopyData() {
            if (confirm(this.$t('Do you want to start copy action?'))) {
                this.$root.post('file', {
                    'action': 'copyFileI18n',
                    'sourceLanguage': this.copySourceLanguage,
                    'targetLanguages': (this.copyLanguagesSelection === 'all' ? '*' : this.copyLanguages.join(',')),
                    'sourceFolders': (this.copyFolderSelection === 'all' ? '*' : this.copyFolders.join(',')),
                })
                    .then((response) => {
                        this.copyUpdate = null
                        if (response.success) {
                            this.copyUpdateCompleted = response.data
                            const _that = this
                            setTimeout(function () {
                                _that.copyUpdateCompleted = null
                            }, 10000)
                        } else {
                            this.disableCopyButton = true
                            this.copyUpdateCompleted = null
                            this.errorMessage = this.$t('Something went wrong. Please contact administrator.')
                            console.log(response.message)
                        }
                        this.copySourceLanguage = ''
                        this.copyLanguagesSelection = ''
                        this.copyFolderSelection = ''
                    })
            }
        },
        updateTradosData() {
            this.$root.fetch(this.selectedTradosType, {
                action: 'tradosTranslationCheck',
                sourceLanguage: this.tradosSourceLanguage,
                scope: this.selectedTradosScope,
                scopeId: this.selectedTradosId,
            })
                .then((response) => {
                    if (typeof response.data !== 'undefined') {
                        this.disableTradosButton = false
                        this.tradosUpdate = response.data
                    } else {
                        this.disableTradosButton = true
                        this.tradosUpdate = null
                        this.errorMessage = this.$t('Something went wrong. Please contact administrator.')
                        console.log(response.message)
                    }
                })
        },
        performTradosData() {
            if (confirm(this.$t('Do you want to start TRADOS action?'))) {
                this.tradosProcessing = true
                this.$root.post(this.selectedTradosType, {
                    action: 'tradosTranslation',
                    sourceLanguage: this.tradosSourceLanguage,
                    targetLanguages: this.tradosLanguages.join(','),
                    scope: this.selectedTradosScope,
                    scopeId: this.selectedTradosId,
                })
                    .then((response) => {
                        this.tradosUpdate = null
                        this.tradosProcessing = false
                        if (typeof response.count !== 'undefined') {
                            this.disableTradosButton = false
                            this.tradosUpdateCompleted = response
                            const _that = this
                            setTimeout(function () {
                                _that.tradosUpdateCompleted = null
                            }, 10000)
                        } else {
                            this.disableTradosButton = true
                            this.tradosUpdateCompleted = null
                            this.errorMessage = this.$t('Something went wrong. Please contact administrator.')
                            console.log(response.message)
                        }
                    })
            }
        },
        parseExportLanguages($languages) {
            return $languages.filter(locale => locale !== this.tradosSourceLanguage)
        }
    },
    computed: {
        disableCopyFileI18nButton() {
            return !this.copySourceLanguage || (!this.copyLanguages.length && !this.copyLanguagesSelection) || (!this.copyFolders.length && !this.copyFolderSelection);
        },
        disableTradosCreateXmlButton() {
            return !this.tradosLanguages.length;
        },
    },
    watch: {
        copyLanguagesSelection(newValue) {
            this.copyLanguages = []
            if (newValue) {
                this.availableLanguages.forEach(language => {
                    this.copyLanguages.push(language.locale)
                })
            }
        },
        copyFolderSelection(newValue) {
            this.copyFolders = []
            if (newValue) {
                this.folders.forEach(folder => {
                    this.copyFolders.push(folder.Id)
                })
            }
        },
        copyFolders(newValue) {
            if (!this.disableCopyFileI18nButton && newValue.length) {
                this.updateCopyData()
            }
        },
        copyLanguages(newValue) {
            if (!this.disableCopyFileI18nButton && newValue.length) {
                this.updateCopyData()
            }
        },
        tradosLanguages(newValue) {
            if (!this.disableTradosCreateXmlButton && newValue.length) {
                this.updateTradosData()
            }
        },
        tradosSourceLanguage(newValue) {
            if (!this.disableTradosCreateXmlButton && newValue.length) {
                this.updateTradosData()
            }
        },
        tradosTypes(newValue) {
            if (!this.disableTradosCreateXmlButton && newValue.length) {
                this.updateTradosData()
            }
        },
        tradosScopes(newValue) {
            if (!this.disableTradosCreateXmlButton && newValue.length) {
                this.updateTradosData()
            }
        },
        selectedTradosId(newValue) {
            if (!this.disableTradosCreateXmlButton && newValue.length) {
                this.updateTradosData()
            }
        },
    }
}
</script>

<template>
    <div>
        <h4 class="subtitle is-4">
            <span>{{ $t('Check and create language content for files') }}</span>
            <span class="tooltip">
                <i class="tooltip__arrow mdi mdi-account-question"></i>
                <span class="tooltip__inner">
                    {{ $t('Bulk actions are needed to transfer language content of media and files from selected languages and folders to a defined target language. This function saves many manual clicks and data assignments.') }}
                </span>
            </span>
        </h4>
        <div class="columns">
            <div class="column is-4">
                <bg-form-select
                    :label="'1. ' + $t('Source: language version')"
                    name="--random--1"
                    :addColumnClass="false"
                    placeholder="Bitte auswählen ..."
                    :size="6"
                    aria-required="true"
                    :options="[...[{ Id: 0, CountryI18ns: [{ Id: 0, Locale: 'de_AT', Name: 'International' }], Languages: [{ Id: 0, CountryId: 0, LocaleCode: 'zz_ZZ', LanguageI18ns: [{ Id: 0, Locale: 'de_AT', Name: 'Ohne Sprache (alt)' }] }] }], ...$root.countries]"
                    @sync="value => copySourceLanguage = value"
                    :option-group="option => option.Languages"
                    :option-group-label="option => $root.translation(option.CountryI18ns, null, 'de_AT').Name"
                    :option-id="option => option.LocaleCode"
                    :option-label="option => $root.translation(option.LanguageI18ns, null, 'de_AT').Name + ' (' + option.LocaleCode + ')'"/>
            </div>
            <div class="column is-4">
                <b-field v-if="folders" :addons="false" :label="'2. ' + $t('Source: folders')">
                    <div class="control is-clearfix">
                        <b-checkbox native-value="all"
                                    :disabled="!!massActionStatus.processing"
                                    v-model="copyFolderSelection"
                                    aria-checked="true">
                            {{ $t('All folders') }}
                        </b-checkbox>
                    </div>
                    <div class="control is-clearfix" style="height: 350px;overflow-y: auto;">
                        <b-checkbox :native-value="folder.Id"
                                    v-model="copyFolders"
                                    :disabled="!!massActionStatus.processing"
                                    style="width:100%;"
                                    v-for="(folder, key) in folders"
                                    :key="key">
                            {{ $root.translation(folder.FolderI18ns, {}, $root.Storage.get('settings').interfaceLanguage).Name }} | {{ folder.Shortcut }} | {{ folder.CollectionType.PhpObject }}
                        </b-checkbox>
                    </div>
                </b-field>
            </div>
            <div class="column is-4">
                <b-field :addons="false" :label="'3. ' + $t('Target: language versions')">
                    <div class="control is-clearfix">
                        <b-checkbox native-value="all"
                                    :disabled="!!massActionStatus.processing"
                                    v-model="copyLanguagesSelection"
                                    aria-checked="true">
                            {{ $t('All languages') }}
                        </b-checkbox>
                    </div>
                    <div class="control is-clearfix">
                        <b-checkbox :native-value="availableLanguage.locale"
                                    v-model="copyLanguages"
                                    :disabled="!!massActionStatus.processing"
                                    v-for="(availableLanguage, key) in availableLanguages"
                                    :key="key">
                            {{ availableLanguage.locale }}&nbsp;&nbsp;
                        </b-checkbox>
                    </div>
                </b-field>

                <div v-if="copyUpdate">
                    <p>{{ $t('This amount of translation will be created on submit') }}:</p>
                    <ul>
                        <li v-for="(item, locale) in copyUpdate" :key="locale">
                            {{ locale }}: {{ item }}
                        </li>
                    </ul>
                    <br>
                </div>

                <button @click="performCopyData()"
                        class="button is-primary"
                        :disabled="disableCopyButton || !!massActionStatus.processing">
                    {{ $t('Perform') }}
                </button>

                <div v-if="copyUpdateCompleted">
                    <br>
                    <p>{{ $t('Successfully created') }}:</p>
                    <ul>
                        <li v-for="(item, locale) in copyUpdateCompleted" :key="locale">
                            {{ locale }}: {{ item }}
                        </li>
                    </ul>
                </div>

                <div v-if="massActionStatus.processing">
                    <br>
                    <p>{{ $t('Processing since') }}: {{ massActionStatus.processing | dateUnix }}</p>
                </div>
            </div>
        </div>

        <hr>

        <h4 class="subtitle is-4">
            <span>{{ $t('TRADOS translations') }}</span>
            <span class="tooltip">
                <i class="tooltip__arrow mdi mdi-account-question"></i>
                <span class="tooltip__inner">
                    {{ $t('Translation jobs for Trados are generated here in the form of XML files. Completed jobs from Trados are reimported every 2 hours.') }}
                </span>
            </span>
        </h4>

        <div class="columns">
            <div class="column is-3">
                <bg-form-select
                    :label="'1. ' + $t('Source: language version')"
                    name="--random--2"
                    :addColumnClass="false"
                    :size="2"
                    aria-required="true"
                    :prefill="$root.$i18n.locale"
                    :options="$root.countries"
                    @sync="value => tradosSourceLanguage = value"
                    :option-group="option => option.Languages"
                    :option-group-label="option => $root.translation(option.CountryI18ns, null, 'de_AT').Name"
                    :option-id="option => option.LocaleCode"
                    :option-label="option => $root.translation(option.LanguageI18ns, null, 'de_AT').Name + ' (' + option.LocaleCode + ')'"/>
            </div>
            <div class="column is-3">
                <bg-form-select
                    :label="'2. ' + $t('Type')"
                    name="--random--3"
                    :addColumnClass="false"
                    :size="2"
                    aria-required="true"
                    :disabled="tradosProcessing"
                    :options="tradosTypes"
                    :prefill="selectedTradosType"
                    @sync="value => selectedTradosType = value"
                    :option-id="option => option.value"
                    :option-label="option => option.label"/>
            </div>
            <div class="column is-3">
                <bg-form-select
                    :label="'3. ' + $t('Scope')"
                    name="--random--4"
                    :addColumnClass="false"
                    :size="2"
                    :disabled="tradosProcessing"
                    aria-required="true"
                    :options="tradosScopes"
                    :prefill="selectedTradosScope"
                    @sync="value => selectedTradosScope = value"
                    :option-id="option => option.value"
                    :option-label="option => option.label"/>
                <b-input v-if="selectedTradosScope === 'id'" v-model="selectedTradosId" :placeholder="$t('ID')"/>
            </div>
            <div class="column is-3">
                <b-field :addons="false" :label="'4. ' + $t('Target: language versions')">
                    <div class="control is-clearfix" v-for="(availableLanguage, key) in exportGroups">
                        <b-checkbox :native-value="parseExportLanguages(availableLanguage).join('|')"
                                    v-model="tradosLanguages"
                                    :disabled="tradosProcessing"
                                    :key="key">
                            {{ parseExportLanguages(availableLanguage).join(', ') }}&nbsp;&nbsp;
                        </b-checkbox>
                    </div>
                </b-field>

                <div v-if="tradosUpdate !== null">
                    <p>
                        {{ $t('This amount of translation will be passed to TRADOS on submit') }}:
                        <span v-html="tradosUpdate"></span>
                    </p>
                    <br>
                </div>

                <button @click="performTradosData()"
                        class="button is-primary"
                        :disabled="disableTradosButton || tradosProcessing">
                    {{ $t('Perform') }}
                </button>

                <div v-if="tradosUpdateCompleted">
                    <br>
                    <p>{{ $t('Successfully created {languages} files with each {count} item.', {languages: tradosUpdateCompleted.languages, count: tradosUpdateCompleted.count}) }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
